import { ChangeDetectionStrategy, Component, computed, inject, model, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import {
	MatDatepicker,
	MatDatepickerInput,
	MatDatepickerInputEvent,
	MatDatepickerToggle,
} from '@angular/material/datepicker';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIconButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { NgxMatTimepickerComponent } from 'ngx-mat-timepicker';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { DetectValueChangeOnFocusOutDirective } from '@/common/detect-value-change-on-focus-out/detect-value-change-on-focus-out.directive';
import { PolishDateAdapter } from '@/common/polish-date-adapter/polish-date-adapter';

@Component({
	selector: 'app-date-time-form',
	standalone: true,
	imports: [
		MatDatepicker,
		MatDatepickerInput,
		MatDatepickerToggle,
		MatFormField,
		MatIconButton,
		MatInput,
		MatSuffix,
		NgxMatTimepickerComponent,
		ReactiveFormsModule,
		FormsModule,
		DetectValueChangeOnFocusOutDirective,
	],
	templateUrl: './date-time-form.component.html',
	styleUrl: './date-time-form.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{ provide: DateAdapter, useClass: PolishDateAdapter }],
})
export class DateTimeFormComponent implements OnInit {
	readonly timeDeparture = model.required<string>();

	readonly formGroup = computed(() => {
		const timeDeparture = new Date(this.timeDeparture());

		return this.fb.group({
			date: [timeDeparture],
			time: [this.datePipe.transform(timeDeparture, 'HH:mm')],
		});
	});

	private readonly fb = inject(FormBuilder);
	private readonly dateAdapter = inject(DateAdapter);
	private readonly datePipe = inject(DatePipe);

	ngOnInit(): void {
		this.dateAdapter.setLocale('pl-PL');
	}

	setTime(value: string): void {
		this.updateTimeDeparture(this.formGroup().get('date').value, value);
	}

	setDate(event: MatDatepickerInputEvent<string, unknown>): void {
		this.updateTimeDeparture(new Date(event.value), this.formGroup().get('time').value);
	}

	private updateTimeDeparture(selectedDate: Date, selectedTime: string): void {
		const [selectedHours, selectedMinutes] = selectedTime.split(':').map(Number);

		if (isNaN(selectedHours) || isNaN(selectedMinutes)) {
			console.error('Invalid time format');
			return;
		}

		const updatedTimeDeparture = new Date(
			selectedDate.getFullYear(),
			selectedDate.getMonth(),
			selectedDate.getDate(),
			selectedHours,
			selectedMinutes,
			0,
		);

		this.timeDeparture.set(updatedTimeDeparture.toISOString());
	}
}
